import { render } from "./form.vue?vue&type=template&id=d1c22072&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=d1c22072&lang=scss&scoped=true"
import "./form.vue?vue&type=style&index=1&id=d1c22072&lang=scss"
script.render = render
script.__scopeId = "data-v-d1c22072"

export default script